module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e1871903e042f246748298a915bee971.png";